import { clsx } from 'clsx';

export interface BadgeProps {
  variant?: 'primary' | 'secondary' | 'success' | 'warning' | 'error' | 'gray';
  color?: 'red' | 'yellow' | 'green' | 'blue' | 'purple' | 'gray';
  size?: 'sm' | 'md';
  children: React.ReactNode;
  className?: string;
}

const variants = {
  primary: 'bg-primary-100 text-primary-800',
  secondary: 'bg-blue-100 text-blue-800',
  success: 'bg-green-100 text-green-800',
  warning: 'bg-yellow-100 text-yellow-800',
  error: 'bg-red-100 text-red-800',
  gray: 'bg-gray-100 text-gray-800',
};

const colors = {
  red: 'bg-red-100 text-red-800',
  yellow: 'bg-yellow-100 text-yellow-800',
  green: 'bg-green-100 text-green-800',
  blue: 'bg-blue-100 text-blue-800',
  purple: 'bg-purple-100 text-purple-800',
  gray: 'bg-gray-100 text-gray-800',
};

const sizes = {
  sm: 'px-2 py-0.5 text-xs',
  md: 'px-2.5 py-0.5 text-sm',
};

export const Badge: React.FC<BadgeProps> = ({ 
  variant = 'gray', 
  color,
  size = 'md', 
  children, 
  className 
}) => {
  return (
    <span
      className={clsx(
        'inline-flex items-center font-medium rounded-full',
        color ? colors[color] : variants[variant],
        sizes[size],
        className
      )}
    >
      {children}
    </span>
  );
};